<template>
  <div class="content">
    <div class="maskCountry">
      <CommonLang v-model="showPopup" :overlay="false"></CommonLang>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Country',
  components: {},
  data() {
    return {
      showPopup: true
    }
  },
  methods: {},
  mounted() {
    if (this.GET_PLATFORM) {
      this.$jumpTo('/home', {}, { replace: true })
    }
    this.showPopup = true
  }
}
</script>
<style lang="less" scoped>
.maskCountry {
  background: url(../../assets/img/otgame/beijing.jpg) no-repeat;
  background-size: 100% 100%;
  height: 100vh;
  overflow: auto;
}
</style>
